<template>
  <div class="confirm-overlay" v-if="open" @click.self="cancel" @keydown.esc="cancel">
    <div class="confirm-dialog" role="alertdialog" aria-modal="true" :aria-labelledby="titleId" :aria-describedby="messageId">
      <div class="confirm-icon" :class="tone" aria-hidden="true">
        <i :class="icon"></i>
      </div>
      <h3 :id="titleId" class="font_helvetica_neue75_bold">{{ title }}</h3>
      <p :id="messageId" class="confirm-message">{{ message }}</p>
      <div class="confirm-actions">
        <button type="button" class="confirm-btn confirm-btn--cancel" @click="cancel" :disabled="loading">
          {{ cancelText }}
        </button>
        <button ref="confirmButton" type="button" class="confirm-btn" :class="'confirm-btn--' + tone" @click="$emit('confirm')" :disabled="loading">
          {{ loading ? 'Procesando…' : confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Confirmación con el estilo de los cuadros del panel (reemplaza window.confirm).
 * tone: "danger" (desactivar, eliminar) o "primary" (reactivar).
 */
let uid = 0;
export default {
  name: "ConfirmDialog",
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, required: true },
    message: { type: String, default: "" },
    confirmText: { type: String, default: "Confirmar" },
    cancelText: { type: String, default: "Cancelar" },
    tone: { type: String, default: "danger" },
    icon: { type: String, default: "fas fa-exclamation-triangle" },
    loading: { type: Boolean, default: false },
  },
  emits: ["confirm", "cancel"],
  data() {
    uid += 1;
    return { titleId: "confirm-title-" + uid, messageId: "confirm-message-" + uid };
  },
  watch: {
    // Al abrir, el foco va al botón de confirmar; Esc o clic afuera cancelan.
    open(value) {
      if (value) this.$nextTick(() => this.$refs.confirmButton && this.$refs.confirmButton.focus());
    },
  },
  methods: {
    cancel() {
      if (!this.loading) this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 1rem;
}
.confirm-dialog {
  background: #fff;
  border-radius: 1rem;
  padding: 1.75rem 1.5rem 1.5rem;
  width: 100%;
  max-width: 26rem;
  text-align: center;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.25);
  h3 {
    margin: 0.75rem 0 0.5rem;
    color: #092f1c;
    font-size: 1.2rem;
  }
}
.confirm-icon {
  width: 3.25rem;
  height: 3.25rem;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
  &.danger {
    background: #fdecea;
    color: #b3261e;
  }
  &.primary {
    background: #e6f2ea;
    color: #256b3a;
  }
}
.confirm-message {
  margin: 0 0 1.25rem;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.45;
}
.confirm-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}
.confirm-btn {
  flex: 1;
  height: 44px;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  color: #fff;
  &:disabled {
    opacity: 0.6;
    cursor: wait;
  }
  &:focus-visible {
    outline: 2px solid #092f1c;
    outline-offset: 2px;
  }
}
.confirm-btn--cancel {
  background: #f1f1f1;
  color: #333;
}
.confirm-btn--danger {
  background: #b3261e;
}
.confirm-btn--primary {
  background: #092f1c;
}
</style>
